import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import { ActionPromptType } from "./action-prompt-type";
import completeActionPromptHandler from "./complete-action-prompt.handler";
import { login } from "../user/login.handler";
import { loginFulfilledForActionPromptsHandler } from "./login-action-prompts.handler";

export interface IActionPromptsState extends IRequestState {
    items: ActionPromptType[]
};

const initialState: IActionPromptsState = {
    items: [],

    loading: false,
    error: "",
};

const actionPromptsSlice = createSlice({
    name: 'actionPrompts',
    initialState,
    reducers: {
        removePromptItem: (state: IActionPromptsState, action: PayloadAction<number>) => {
            state.items = state.items.filter(item => item !== action.payload);
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<IActionPromptsState>) => {
        completeActionPromptHandler(builder);
        builder.addCase(login.fulfilled, loginFulfilledForActionPromptsHandler);
    },
});

export default actionPromptsSlice.reducer;
export const { removePromptItem } = actionPromptsSlice.actions;